import { api } from "shared/config/api/api";
import { PROMO_V1_URL } from "entities/wheel-raffle";
import type { DrawWheelRaffleResponse } from "entities/wheel-raffle";

export const drawWheelRaffleApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // Закрывает окно и разыгрывает призы. Инвалидация и на ошибке:
    // при 409 already_drawn экран тоже должен подтянуть свежий статус.
    drawWheelRaffle: builder.mutation<DrawWheelRaffleResponse, number>({
      query: (raffleId) => ({
        url: `${PROMO_V1_URL}/wheel-raffles/${raffleId}/draw-now`,
        method: "POST",
        body: {},
      }),
      invalidatesTags: ["WheelRaffle"],
    }),
  }),
});

export const { useDrawWheelRaffleMutation } = drawWheelRaffleApi;
